import { FETCH_ORG_PROFILE_DATA_SUCCESS, SET_UPDATING_DATA, UPDATE_ORG_PROFILE_INFO_SUCCESS, 
  FETCH_ORG_PROPERTY_LOCATION_SUCCESS, REMOVE_ORG_LOGO_SUCCESS, UPDATE_ORG_LOGO, SET_UPDATING_ORG_DATA, UPDATE_ORG_IMAGE_URL, 
  FETCH_ORGSKILLSETS_SUCCESS} from "../../AdminPanel/actions/actionConstants";

const initialState = {
  orgProfileData: {},
  updatingData: null,
  timezoneData:{},
  hostName:"",
  orgSkillSets:[],
  zipLocSuggestion:[],
  countries:"",
  serviceLocData:{}
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_ORG_PROFILE_DATA_SUCCESS:{
      return Object.assign({}, state, {orgProfileData:Object.assign({},action.payload.orgProfileData,{OrgSkillsList:action.payload.OrganizationSkills}), timezoneData:action.payload.timezoneData,hostName:action.payload.hostName, countries:action.payload.Countries,
      serviceLocData:action.payload.serviceLocData, orgSkillSets: action.payload.orgSkillSets});
    }

    case SET_UPDATING_DATA: {
        return Object.assign({}, state, { updatingData: action.payload.key });
    }

    case FETCH_ORG_PROPERTY_LOCATION_SUCCESS:{
          return Object.assign({}, state, { zipLocSuggestion: action.payload });
    }

    case FETCH_ORGSKILLSETS_SUCCESS:{
      return Object.assign({}, state, { orgSkillSets: action.payload });
    }

    case UPDATE_ORG_PROFILE_INFO_SUCCESS: {
      const updateData = action.payload;
      let updateorgProfileInfo = {};
      if (updateData.mode == "companyName") {
        updateorgProfileInfo = Object.assign({}, state.orgProfileData, { OrganizationName: updateData.orgName });
          return Object.assign({}, state, { orgProfileData: updateorgProfileInfo });
      }
      else if(updateData.mode == "subDomain")
      {
        updateorgProfileInfo = Object.assign({}, state.orgProfileData, { Subdomain: updateData.subDomain });
        return Object.assign({}, state, { orgProfileData: updateorgProfileInfo });
      }
      else if(updateData.mode == "phone")
      {
        updateorgProfileInfo = Object.assign({}, state.orgProfileData, { Phone: updateData.phone });
        return Object.assign({}, state, { orgProfileData: updateorgProfileInfo });
      }
      else if(updateData.mode == "fax")
      {
        updateorgProfileInfo = Object.assign({}, state.orgProfileData, { Fax: updateData.fax });
        return Object.assign({}, state, { orgProfileData: updateorgProfileInfo });
      }
      else if(updateData.mode =="timezone")
      {
        updateorgProfileInfo = Object.assign({}, state.orgProfileData, { OrgTimeZoneTz: updateData.universalTimeZoneId });
        return Object.assign({}, state, { orgProfileData: updateorgProfileInfo });
      }
      else if(updateData.mode =="timezone")
      {
        updateorgProfileInfo = Object.assign({}, state.orgProfileData, { OrgTimeZoneTz: updateData.universalTimeZoneId });
        return Object.assign({}, state, { orgProfileData: updateorgProfileInfo });
      }
      break;
    }

    case REMOVE_ORG_LOGO_SUCCESS:
    case UPDATE_ORG_IMAGE_URL:
    case UPDATE_ORG_LOGO:{
      return Object.assign({}, state, {orgProfileData:Object.assign({},state.orgProfileData,{ProfileFullImage:action.payload})});
     }

     case SET_UPDATING_ORG_DATA:{
      return Object.assign({}, state, {orgProfileData:Object.assign({},state.orgProfileData,{IsProfileComplete:action.payload})});
     }
  
    default:
      return state;
  }
}
